import React from 'react';

const MainMenu = ({ onStartGame, onShowTutorial, onShowKnowledge }) => {
  return (
    <div style={{ textAlign: 'center', padding: '60px 20px', fontFamily: 'sans-serif' }}>
      <h1 style={{ fontSize: '48px', color: '#ff4757', marginBottom: '10px' }}>ยอดเชฟ 4 ภาค</h1>
      <h2 style={{ fontSize: '24px', color: '#57606f', marginTop: 0, marginBottom: '40px' }}>Thai Regional Chef Game</h2>
      
      <p style={{ color: '#747d8c', marginBottom: '50px', maxWidth: '500px', margin: '0 auto 50px auto', lineHeight: '1.6' }}>
        บริหารร้านอาหาร ผสมการ์ดวัตถุดิบเพื่อสร้างสรรค์เมนูเด็ด 4 ภาค 
        ในรูปแบบเกมการ์ดสไตล์ Roguelite พร้อมเรียนรู้ประวัติศาสตร์อาหารไทย
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
        
        {/* 🌟 ปุ่มใหม่ โหมด Balatro */}
        <button 
          onClick={() => onStartGame('balatro')}
          style={{ padding: '15px 40px', fontSize: '20px', fontWeight: 'bold', backgroundColor: '#9b59b6', color: 'white', border: 'none', borderRadius: '50px', cursor: 'pointer', boxShadow: '0 4px 15px rgba(155, 89, 182, 0.4)', width: '280px' }}
        >
          โหมดเซียนกระทะ (อิสระ) 🃏
        </button>

        <button 
          onClick={() => onStartGame('normal')}
          style={{ padding: '12px 40px', fontSize: '16px', fontWeight: 'bold', backgroundColor: '#2ed573', color: 'white', border: 'none', borderRadius: '50px', cursor: 'pointer', width: '280px' }}
        >
          เริ่มเปิดร้าน (จัดการงบ) 🚀
        </button>

        <button 
          onClick={() => onStartGame('kids')}
          style={{ padding: '12px 40px', fontSize: '16px', fontWeight: 'bold', backgroundColor: '#3742fa', color: 'white', border: 'none', borderRadius: '50px', cursor: 'pointer', width: '280px' }}
        >
          โหมดเด็กประถม 🧒✨
        </button>
        
        <button 
          onClick={onShowKnowledge}
          style={{ padding: '12px 40px', fontSize: '16px', fontWeight: 'bold', backgroundColor: '#ffa502', color: 'white', border: 'none', borderRadius: '50px', cursor: 'pointer', width: '280px', marginTop: '10px' }}
        >
          สาระความรู้ 📚
        </button>

        <button 
          onClick={onShowTutorial}
          style={{ padding: '12px 40px', fontSize: '16px', fontWeight: 'bold', backgroundColor: '#f1f2f6', color: '#2f3542', border: '2px solid #ced6e0', borderRadius: '50px', cursor: 'pointer', width: '280px' }}
        >
          วิธีเล่น (Tutorial) 📖
        </button>
      </div>
    </div>
  );
};

export default MainMenu;